// src/auth/RequireAuth.js
import { useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

export default function RequireAuth({ children }) {
  const [checking, setChecking] = useState(true);
  const [authorized, setAuthorized] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        navigate("/login", { replace: true });
        setChecking(false);
        return;
      }

      // Check if user document exists in Firestore
      // If it exists, they're verified. If not, they need to verify.
      const userDoc = await getDoc(doc(db, "users", user.uid));
      
      if (userDoc.exists()) {
        setAuthorized(true);
      } else {
        // No user doc = not verified yet
        navigate("/verify-email", { replace: true });
      }
      
      setChecking(false);
    });

    return () => unsub();
  }, [navigate]);

  if (checking) {
    return (
      <div style={{ color: "white", textAlign: "center", padding: "40px" }}>
        Checking account...
      </div>
    );
  }

  return authorized ? <>{children}</> : null;
}